import React from 'react';
import TryThisOut from '../../pages/tryNow/TryThisOut';

function UaeVisaOCR({ currentProduct }) {
  return (
    <>
      <TryThisOut currentProduct={currentProduct} />
    </>
  );
}

export default UaeVisaOCR;
